import { filters } from "domains/concierge/internal/util/conversationGroupFilters";
import { sortOptions } from "domains/concierge/internal/util/conversationGroupSortOptions";

import { useConversationCount } from "./useConversationCount";

export const useAllConversationsFailedMessagesConversationCount = () => {
    return useConversationCount(filters.allFailed(), sortOptions.allFailed());
};
